import 'quill/dist/quill.snow.css';

export default function Editor({ quillRef, classname = "" }) {
    return (
        <div className={`w-full ${classname}`}>
            <div className='border h-full bg-white' ref={quillRef} />
        </div>
    );
}
